import get from "lodash/get";
import { formatAsCrore, formatAsPercentage } from "creso-core/utils";
import { sipCalculatorRowConfig } from "./config";

export function BacktestCell({
  label,
  data,
}: {
  label: string;
  data: {
    cagr?: number;
    standard_deviation?: number;
    max_drawdown?: number;
    total_invested?: number;
    portfolio_value?: number;
  };
}) {
  const accessor = sipCalculatorRowConfig.find(
    (config) => config.label === label
  )?.accessor;

  if (!accessor) {
    return <span className="text-sm">N/A</span>;
  }

  if (accessor === "cagr") {
    return (
      <span className="text-sm">
        {formatAsPercentage(get(data, accessor, "0"), "0", 2)}
      </span>
    );
  }

  if (accessor === "total_invested" || accessor === "portfolio_value")
    return (
      <span className="text-sm">
        {formatAsCrore(get(data, accessor, "N/A"), 2)}
      </span>
    );
  return <span className="text-sm">{get(data, accessor, "N/A")}</span>;
}
